import { render } from "./AdditionalCosts.vue?vue&type=template&id=8815a79c"
import script from "./AdditionalCosts.vue?vue&type=script&lang=js"
export * from "./AdditionalCosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__